import { useLayoutEffect, useRef } from 'react'
import { refreshUpdateBlockers, registerUpdateGuard } from '../services/appUpdateService'

export default function useUpdateBlocker(blocked, key = null, persist = blocked) {
  const blockedRef = useRef(blocked)
  const persistRef = useRef(persist)
  blockedRef.current = blocked
  persistRef.current = persist
  const read = (value) => typeof value === 'function' ? value() : Boolean(value)
  useLayoutEffect(() => registerUpdateGuard(() => read(blockedRef.current), key,
    () => read(persistRef.current)), [key])
  useLayoutEffect(() => { refreshUpdateBlockers() })
}
